import { render } from "./Designs.vue?vue&type=template&id=56ac2d0f&scoped=true"
import script from "./Designs.vue?vue&type=script&lang=js"
export * from "./Designs.vue?vue&type=script&lang=js"

import "./Designs.vue?vue&type=style&index=0&id=56ac2d0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ac2d0f"]])

export default __exports__